/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A labelled slice of the customer's shipments with its share of the
 * whole — used for pickup locations, accessorials, weight and density
 * bands, and months.
 *
 * @export
 * @interface OpportunityBreakdown
 */
export interface OpportunityBreakdown {
  /**
   *
   * @type {string}
   * @memberof OpportunityBreakdown
   */
  label: string;
  /**
   *
   * @type {number}
   * @memberof OpportunityBreakdown
   */
  shipmentCount: number;
  /**
   * Share of the window's shipments, 0 to 1.
   * @type {number}
   * @memberof OpportunityBreakdown
   */
  sharePercentage: number;
}

/**
 * Check if a given object implements the OpportunityBreakdown interface.
 */
export function instanceOfOpportunityBreakdown(
  value: object,
): value is OpportunityBreakdown {
  if (!("label" in value) || value["label"] === undefined) return false;
  if (!("shipmentCount" in value) || value["shipmentCount"] === undefined)
    return false;
  if (!("sharePercentage" in value) || value["sharePercentage"] === undefined)
    return false;
  return true;
}

export function OpportunityBreakdownFromJSON(json: any): OpportunityBreakdown {
  return OpportunityBreakdownFromJSONTyped(json, false);
}

export function OpportunityBreakdownFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunityBreakdown {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"],
    shipmentCount: json["shipmentCount"],
    sharePercentage: json["sharePercentage"],
  };
}

export function OpportunityBreakdownToJSON(json: any): OpportunityBreakdown {
  return OpportunityBreakdownToJSONTyped(json, false);
}

export function OpportunityBreakdownToJSONTyped(
  value?: OpportunityBreakdown | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    shipmentCount: value["shipmentCount"],
    sharePercentage: value["sharePercentage"],
  };
}
